export const notify = (message) => {
  if (typeof window === 'undefined') return;
  const safeMessage = String(message || 'Une erreur est survenue.');
  window.dispatchEvent(
    new CustomEvent('booktube:alert', {
      detail: { message: safeMessage }
    })
  );
};

